<template>
  <div class="section section--alt-background">
    <div class="container max-width-mobile">
      <div
        class="users"
        :class="{
          'users--split': orderRoom.orderIsSplit,
          [`users--${orderRoom.otherUsers.length + 1}`]: true
        }"
      >
        <transition-group
          name="user"
          class="users__wrapper"
          tag="div"
        >
          <button
            key="you"
            class="users__user users__user--you"
            :class="{
              'users__user--paid': orderRoom.you.paid
            }"
            type="button"
            @click="showUserSettings"
          >
            <div
              v-if="merchant.options.skinOptions.avatarType === 'funky'"
              class="users__avatar users__avatar--custom-image"
              :style="{
                'background-image': `url(/images/avatars/funky/${orderRoom.you.index}.svg)`
              }"
            />

            <div
              v-else
              class="users__avatar"
            >
              <div class="users__avatar-text">
                {{ $initial(orderRoom.you.nickname) }}
              </div>
            </div>

            <span class="users__nickname">
              {{ orderRoom.you.nickname }}
            </span>

            <span
              v-show="!orderRoom.you.paid"
              class="users__tap-to-edit"
            >
              Tap to Edit
            </span>

            <span
              v-show="orderRoom.orderIsSplit && orderRoom.you.paid"
              class="users__status"
            >
              Authed
            </span>
          </button>

          <div
            key="message"
            class="users__default-content"
          >
            <img
              class="illustration illustration--party illustration--white"
              src="/images/illustrations/party-white.svg"
              alt=""
              role="presentation"
            >

            <img
              class="illustration illustration--party illustration--black"
              src="/images/illustrations/party-black.svg"
              alt=""
              role="presentation"
            >

            <p class="title title--6 no-spacing">
              {{ content.PayAtTable.metadata.billSplitTitle }}
            </p>

            <p class="smaller">
              <!-- Ask your friends to scan your {{ $lowercase(userLocationType.description) }}'s QR code. -->
              {{ content.PayAtTable.metadata.billSplitDescription }}
            </p>
          </div>

          <div
            v-for="user in orderRoom.otherUsers"
            :key="user.id"
            class="users__user"
            :class="{
              'users__user--paid': user.paid
            }"
          >
            <div
              v-if="merchant.options.skinOptions.avatarType === 'funky'"
              class="users__avatar users__avatar--custom-image"
              :style="{
                'background-image': `url(/images/avatars/funky/${user.index}.svg)`
              }"
            />

            <div
              v-else
              class="users__avatar"
            >
              <div class="users__avatar-text">
                {{ $initial(user.nickname) }}
              </div>
            </div>

            <span class="users__nickname">
              {{ user.nickname }}
            </span>

            <span
              v-show="user.paid"
              class="users__status"
            >
              Authed
              <span class="dark">{{ $dollars(user.total) }}</span>
            </span>
            <span
              v-show="!user.paid"
              class="users__status"
            >
              Pending
              <span class="dark">{{ $dollars(user.total) }}</span>
            </span>
          </div>
        </transition-group>
      </div>
    </div>



    <modal
      name="userSettings"
      modal-style="compact"
    >
      <div class="section">
        <validated-form
          name="userOptions"
          @valid-submit="updateUserSettings"
        >
          <h2 class="title title--3">Choose a Nickname</h2>

          <div class="input-with-button input-with-button--merge">
            <div class="input-with-button__input">
              <text-input
                v-model="newNickname"
                type="text"
                label="Your Nickname"
                name="nickname"
              />
            </div>

            <div class="input-with-button__button">
              <button
                class="button button--primary button--large"
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>

          <div class="layout layout--icon">
            <span class="icon far fa-info-circle gray" />
            <p>This nickname will be displayed to other guests splitting your bill.</p>
          </div>
        </validated-form>
      </div>
    </modal>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'UserList',

    data() {
      return {
        newNickname: null
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('orders', ['userLocationType']),
      ...mapGetters('socket', ['orderRoom'])
    },

    methods: {
      hideUserSettings() {
        this.$closeModal('userSettings');
      },

      showUserSettings() {
        this.$openModal('userSettings');
      },

      updateUserSettings() {
        const nickname = this.newNickname || this.orderRoom.you.nickname;
        this.newNickname = null;

        this.hideUserSettings();

        this.$store.dispatch('socket/profileUpdate', {
          nickname
        });
      }
    }
  };
</script>
